function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/* globals Node */

/**
 * @module engine/view/renderer
 */
import ViewText from './text';
import ViewPosition from './position';
import { INLINE_FILLER, INLINE_FILLER_LENGTH, startsWithFiller, isInlineFiller } from './filler';
import mix from '@ckeditor/ckeditor5-utils/src/mix';
import diff from '@ckeditor/ckeditor5-utils/src/diff';
import insertAt from '@ckeditor/ckeditor5-utils/src/dom/insertat';
import remove from '@ckeditor/ckeditor5-utils/src/dom/remove';
import ObservableMixin from '@ckeditor/ckeditor5-utils/src/observablemixin';
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
import isText from '@ckeditor/ckeditor5-utils/src/dom/istext';
import isNode from '@ckeditor/ckeditor5-utils/src/dom/isnode';
import fastDiff from '@ckeditor/ckeditor5-utils/src/fastdiff';
import env from '@ckeditor/ckeditor5-utils/src/env';
/**
 * Renderer is responsible for updating the DOM structure and the DOM selection based on
 * the {@link module:engine/view/renderer~Renderer#markToSync information about updated view nodes}.
 * In other words, it renders the view to the DOM.
 *
 * Its main responsibility is to make only the necessary, minimal changes to the DOM. However, unlike in many
 * virtual DOM implementations, the primary reason for doing minimal changes is not the performance but ensuring
 * that native editing features such as text composition, autocompletion, spell checking, selection's x-index are
 * affected as little as possible.
 *
 * Renderer uses {@link module:engine/view/domconverter~DomConverter} to transform view nodes and positions
 * to and from the DOM.
 */

var Renderer = /*#__PURE__*/function () {
  /**
   * Creates a renderer instance.
   *
   * @param {module:engine/view/domconverter~DomConverter} domConverter Converter instance.
   * @param {module:engine/view/documentselection~DocumentSelection} selection View selection.
   */
  function Renderer(domConverter, selection) {
    _classCallCheck(this, Renderer);

    /**
     * Set of DOM Documents instances.
     *
     * @readonly
     * @member {Set.<Document>}
     */
    this.domDocuments = new Set();
    /**
     * Converter instance.
     *
     * @readonly
     * @member {module:engine/view/domconverter~DomConverter}
     */

    this.domConverter = domConverter;
    /**
     * Set of nodes which attributes changed and may need to be rendered.
     *
     * @readonly
     * @member {Set.<module:engine/view/node~Node>}
     */

    this.markedAttributes = new Set();
    /**
     * Set of elements which child lists changed and may need to be rendered.
     *
     * @readonly
     * @member {Set.<module:engine/view/node~Node>}
     */

    this.markedChildren = new Set();
    /**
     * Set of text nodes which text data changed and may need to be rendered.
     *
     * @readonly
     * @member {Set.<module:engine/view/node~Node>}
     */

    this.markedTexts = new Set();
    /**
     * View selection. Renderer updates DOM selection based on the view selection.
     *
     * @readonly
     * @member {module:engine/view/documentselection~DocumentSelection}
     */

    this.selection = selection;
    /**
     * Indicates if the view document is focused and selection can be rendered. Selection will not be rendered if
     * this is set to `false`.
     *
     * @member {Boolean}
     */

    this.isFocused = false;
    /**
     * The text node in which the inline filler was rendered.
     *
     * @private
     * @member {Text}
     */

    this._inlineFiller = null;
    /**
     * DOM element containing fake selection.
     *
     * @private
     * @type {null|HTMLElement}
     */

    this._fakeSelectionContainer = null;
  }
  /**
   * Marks a view node to be updated in the DOM by {@link #render `render()`}.
   *
   * Note that only view nodes whose parents have corresponding DOM elements need to be marked to be synchronized.
   *
   * @see #markedAttributes
   * @see #markedChildren
   * @see #markedTexts
   *
   * @param {module:engine/view/document~ChangeType} type Type of the change.
   * @param {module:engine/view/node~Node} node Node to be marked.
   */


  _createClass(Renderer, [{
    key: "markToSync",
    value: function markToSync(type, node) {
      if (type === 'text') {
        if (this.domConverter.mapViewToDom(node.parent)) {
          this.markedTexts.add(node);
        }
      } else {
        // If the node has no DOM element it is not rendered yet,
        // its children/attributes do not need to be marked to be sync.
        if (!this.domConverter.mapViewToDom(node)) {
          return;
        }

        if (type === 'attributes') {
          this.markedAttributes.add(node);
        } else if (type === 'children') {
          this.markedChildren.add(node);
        } else {
          /**
           * Unknown type passed to Renderer.markToSync.
           *
           * @error view-renderer-unknown-type
           */
          throw new CKEditorError('view-renderer-unknown-type', this);
        }
      }
    }
    /**
     * Renders all buffered changes ({@link #markedAttributes}, {@link #markedChildren} and {@link #markedTexts}) and
     * the current view selection (if needed) to the DOM by applying a minimal set of changes to it.
     *
     * Renderer tries not to break the text composition (e.g. IME) and x-index of the selection,
     * so it does as little as it is needed to update the DOM.
     *
     * Renderer also handles {@link module:engine/view/filler fillers}. Especially, it checks if the inline filler is needed
     * at the selection position and adds or removes it. To prevent breaking text composition inline filler will not be
     * removed as long as the selection is in the text node which needed it at first.
     */

  }, {
    key: "render",
    value: function render() {
      var inlineFillerPosition; // Refresh mappings.

      var _iterator = _createForOfIteratorHelper(this.markedChildren),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var element = _step.value;

          this._updateChildrenMappings(element);
        } // There was inline filler rendered in the DOM but it's not
        // at the selection position any more, so we can remove it
        // (cause even if it's needed, it must be placed in another location).

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (this._inlineFiller && !this._isSelectionInInlineFiller()) {
        this._removeInlineFiller();
      } // If we've got the filler, let's try to guess its position in the view.


      if (this._inlineFiller) {
        inlineFillerPosition = this._getInlineFillerPosition();
      } // Otherwise, if it's needed, create it at the selection position.
      else if (this._needsInlineFillerAtSelection()) {
          inlineFillerPosition = this.selection.getFirstPosition(); // Do not use `markToSync` so it will be added even if the parent is already added.

          this.markedChildren.add(inlineFillerPosition.parent);
        }

      var _iterator2 = _createForOfIteratorHelper(this.markedAttributes),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _element = _step2.value;

          this._updateAttrs(_element);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var _iterator3 = _createForOfIteratorHelper(this.markedChildren),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _element2 = _step3.value;

          this._updateChildren(_element2, {
            inlineFillerPosition: inlineFillerPosition
          });
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var _iterator4 = _createForOfIteratorHelper(this.markedTexts),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var node = _step4.value;

          if (!this.markedChildren.has(node.parent) && this.domConverter.mapViewToDom(node.parent)) {
            this._updateText(node, {
              inlineFillerPosition: inlineFillerPosition
            });
          }
        } // Check whether the inline filler is required and where it really is in the DOM.
        // At this point in most cases it will be in the DOM, but there are exceptions.
        // For example, if the inline filler was deep in the created DOM structure, it will not be created.
        // Similarly, if it was removed at the beginning of this function and then neither text nor children were updated,
        // it will not be present.
        // Fix those and similar scenarios.

      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      if (inlineFillerPosition) {
        var fillerDomPosition = this.domConverter.viewPositionToDom(inlineFillerPosition);
        var domDocument = fillerDomPosition.parent.ownerDocument;

        if (!startsWithFiller(fillerDomPosition.parent)) {
          // Filler has not been created at filler position. Create it now.
          this._inlineFiller = addInlineFiller(domDocument, fillerDomPosition.parent, fillerDomPosition.offset);
        } else {
          // Filler has been found, save it.
          this._inlineFiller = fillerDomPosition.parent;
        }
      } else {
        // There is no filler needed.
        this._inlineFiller = null;
      } // First focus the new editing host, then update the selection.
      // Otherwise, FF may throw an error (https://github.com/ckeditor/ckeditor5/issues/721).


      this._updateFocus();

      this._updateSelection();

      this.markedTexts.clear();
      this.markedAttributes.clear();
      this.markedChildren.clear();
    }
    /**
     * Updates mappings of view element's children.
     *
     * Children that were replaced in the view structure by similar elements (same tag name) are treated as 'replaced'.
     * This means that their mappings can be updated so the new view elements are mapped to the existing DOM elements.
     * Thanks to that these elements do not need to be re-rendered completely.
     *
     * @private
     * @param {module:engine/view/node~Node} viewElement The view element whose children mappings will be updated.
     */

  }, {
    key: "_updateChildrenMappings",
    value: function _updateChildrenMappings(viewElement) {
      var domElement = this.domConverter.mapViewToDom(viewElement);

      if (!domElement) {
        // If there is no `domElement` it means that it was already removed from DOM and there is no need to process it.
        return;
      } // Removing nodes from the DOM as we iterate can cause `actualDomChildren`
      // (which is a live-updating `NodeList`) to get out of sync with the
      // indices that we compute as we iterate over `actions`, producing
      // incorrect element mappings.
      //
      // Converting live list to an array to make the list static.


      var actualDomChildren = Array.from(this.domConverter.mapViewToDom(viewElement).childNodes);
      var expectedDomChildren = Array.from(this.domConverter.viewChildrenToDom(viewElement, domElement.ownerDocument, {
        withChildren: false
      }));

      var diff = this._diffNodeLists(actualDomChildren, expectedDomChildren);

      var actions = this._findReplaceActions(diff, actualDomChildren, expectedDomChildren);

      if (actions.indexOf('replace') !== -1) {
        var counter = {
          equal: 0,
          insert: 0,
          delete: 0
        };

        var _iterator5 = _createForOfIteratorHelper(actions),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var action = _step5.value;

            if (action === 'replace') {
              var insertIndex = counter.equal + counter.insert;
              var deleteIndex = counter.equal + counter.delete;
              var viewChild = viewElement.getChild(insertIndex); // UIElement and RawElement are special cases. Their children are not stored in a view (#799)
              // so we cannot use them with replacing flow (since they use view children during rendering
              // which will always result in rendering empty elements).

              if (viewChild && !(viewChild.is('uiElement') || viewChild.is('rawElement'))) {
                this._updateElementMappings(viewChild, actualDomChildren[deleteIndex]);
              }

              remove(expectedDomChildren[insertIndex]);
              counter.equal++;
            } else {
              counter[action]++;
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    }
    /**
     * Updates mappings of a given view element.
     *
     * @private
     * @param {module:engine/view/node~Node} viewElement The view element whose mappings will be updated.
     * @param {Node} domElement The DOM element representing the given view element.
     */

  }, {
    key: "_updateElementMappings",
    value: function _updateElementMappings(viewElement, domElement) {
      // Remap 'DomConverter' bindings.
      this.domConverter.unbindDomElement(domElement);
      this.domConverter.bindElements(domElement, viewElement); // View element may have children which needs to be updated, but are not marked, mark them to update.

      this.markedChildren.add(viewElement); // Because we replace new view element mapping with the existing one, the corresponding DOM element
      // will not be rerendered. The new view element may have different attributes than the previous one.
      // Since its corresponding DOM element will not be rerendered, new attributes will not be added
      // to the DOM, so we need to mark it here to make sure its attributes gets updated. See #1427 for more
      // detailed case study.
      // Also there are cases where replaced element is removed from the view structure and then has
      // its attributes changed or removed. In such cases the element will not be present in `markedAttributes`
      // and also may be the same (`element.isSimilar()`) as the reused element not having its attributes updated.
      // To prevent such situations we always mark reused element to have its attributes rerenderd (#1560).

      this.markedAttributes.add(viewElement);
    }
    /**
     * Gets the position of the inline filler based on the current selection.
     * Here, we assume that we know that the filler is needed and
     * {@link #_isSelectionInInlineFiller is at the selection position}, and, since it is needed,
     * it is somewhere at the selection position.
     *
     * Note: The filler position cannot be restored based on the filler's DOM text node, because
     * when this method is called (before rendering), the bindings will often be broken. View-to-DOM
     * bindings are only dependable after rendering.
     *
     * @private
     * @returns {module:engine/view/position~Position}
     */

  }, {
    key: "_getInlineFillerPosition",
    value: function _getInlineFillerPosition() {
      var firstPos = this.selection.getFirstPosition();

      if (firstPos.parent.is('$text')) {
        return ViewPosition._createBefore(this.selection.getFirstPosition().parent);
      } else {
        return firstPos;
      }
    }
    /**
     * Returns `true` if the selection has not left the inline filler's text node.
     * If it is `true`, it means that the filler had been added for a reason and the selection did not
     * leave the filler's text node. For example, the user can be in the middle of a composition so it should not be touched.
     *
     * @private
     * @returns {Boolean} `true` if the inline filler and selection are in the same place.
     */

  }, {
    key: "_isSelectionInInlineFiller",
    value: function _isSelectionInInlineFiller() {
      if (this.selection.rangeCount != 1 || !this.selection.isCollapsed) {
        return false;
      } // Note, we can't check if selection's position equals position of the
      // this._inlineFiller node, because of #663. We may not be able to calculate
      // the filler's position in the view at this stage.
      // Instead, we check it the other way – whether selection is anchored in
      // that text node or next to it.
      // Possible options are:
      // "FILLER{}"
      // "FILLERadded-text{}"


      var selectionPosition = this.selection.getFirstPosition();
      var position = this.domConverter.viewPositionToDom(selectionPosition);

      if (position && isText(position.parent) && startsWithFiller(position.parent)) {
        return true;
      }

      return false;
    }
    /**
     * Removes the inline filler.
     *
     * @private
     */

  }, {
    key: "_removeInlineFiller",
    value: function _removeInlineFiller() {
      var domFillerNode = this._inlineFiller; // Something weird happened and the stored node doesn't contain the filler's text.

      if (!startsWithFiller(domFillerNode)) {
        /**
         * The inline filler node was lost. Most likely, something overwrote the filler text node
         * in the DOM.
         *
         * @error view-renderer-filler-was-lost
         */
        throw new CKEditorError('view-renderer-filler-was-lost', this);
      }

      if (isInlineFiller(domFillerNode)) {
        domFillerNode.parentNode.removeChild(domFillerNode);
      } else {
        domFillerNode.data = domFillerNode.data.substr(INLINE_FILLER_LENGTH);
      }

      this._inlineFiller = null;
    }
    /**
     * Checks if the inline {@link module:engine/view/filler filler} should be added.
     *
     * @private
     * @returns {Boolean} `true` if the inline filler should be added.
     */

  }, {
    key: "_needsInlineFillerAtSelection",
    value: function _needsInlineFillerAtSelection() {
      if (this.selection.rangeCount != 1 || !this.selection.isCollapsed) {
        return false;
      }

      var selectionPosition = this.selection.getFirstPosition();
      var selectionParent = selectionPosition.parent;
      var selectionOffset = selectionPosition.offset; // If there is no DOM root we do not care about fillers.

      if (!this.domConverter.mapViewToDom(selectionParent.root)) {
        return false;
      }

      if (!selectionParent.is('element')) {
        return false;
      } // Prevent adding inline filler inside elements with contenteditable=false.
      // https://github.com/ckeditor/ckeditor5-engine/issues/1170


      if (!isEditable(selectionParent)) {
        return false;
      } // We have block filler, we do not need inline one.


      if (selectionOffset === selectionParent.getFillerOffset()) {
        return false;
      }

      var nodeBefore = selectionPosition.nodeBefore;
      var nodeAfter = selectionPosition.nodeAfter;

      if (nodeBefore instanceof ViewText || nodeAfter instanceof ViewText) {
        return false;
      }

      return true;
    }
    /**
     * Checks if text needs to be updated and possibly updates it.
     *
     * @private
     * @param {module:engine/view/text~Text} viewText View text to update.
     * @param {Object} options
     * @param {module:engine/view/position~Position} options.inlineFillerPosition The position where the inline
     * filler should be rendered.
     */

  }, {
    key: "_updateText",
    value: function _updateText(viewText, options) {
      var domText = this.domConverter.findCorrespondingDomText(viewText);
      var newDomText = this.domConverter.viewToDom(viewText, domText.ownerDocument);
      var actualText = domText.data;
      var expectedText = newDomText.data;
      var filler = options.inlineFillerPosition;

      if (filler && filler.parent == viewText.parent && filler.offset == viewText.index) {
        expectedText = INLINE_FILLER + expectedText;
      }

      if (actualText != expectedText) {
        var actions = fastDiff(actualText, expectedText);

        var _iterator6 = _createForOfIteratorHelper(actions),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var action = _step6.value;

            if (action.type === 'insert') {
              domText.insertData(action.index, action.values.join(''));
            } else {
              // 'delete'
              domText.deleteData(action.index, action.howMany);
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    }
    /**
     * Checks if attribute list needs to be updated and possibly updates it.
     *
     * @private
     * @param {module:engine/view/element~Element} viewElement The view element to update.
     */

  }, {
    key: "_updateAttrs",
    value: function _updateAttrs(viewElement) {
      var domElement = this.domConverter.mapViewToDom(viewElement);

      if (!domElement) {
        // If there is no `domElement` it means that 'viewElement' is outdated as its mapping was updated
        // in 'this._updateChildrenMappings()'. There is no need to process it as new view element which
        // replaced old 'viewElement' mapping was also added to 'this.markedAttributes'
        // in 'this._updateChildrenMappings()' so it will be processed separately.
        return;
      }

      var domAttrKeys = Array.from(domElement.attributes).map(function (attr) {
        return attr.name;
      });
      var viewAttrKeys = viewElement.getAttributeKeys(); // Add or overwrite attributes.

      var _iterator7 = _createForOfIteratorHelper(viewAttrKeys),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var key = _step7.value;
          domElement.setAttribute(key, viewElement.getAttribute(key));
        } // Remove from DOM attributes which do not exists in the view.

      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      var _iterator8 = _createForOfIteratorHelper(domAttrKeys),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _key = _step8.value;

          if (!viewElement.hasAttribute(_key)) {
            domElement.removeAttribute(_key);
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
    /**
     * Checks if elements child list needs to be updated and possibly updates it.
     *
     * @private
     * @param {module:engine/view/element~Element} viewElement View element to update.
     * @param {Object} options
     * @param {module:engine/view/position~Position} options.inlineFillerPosition The position where the inline
     * filler should be rendered.
     */

  }, {
    key: "_updateChildren",
    value: function _updateChildren(viewElement, options) {
      var domElement = this.domConverter.mapViewToDom(viewElement);

      if (!domElement) {
        // If there is no `domElement` it means that it was already removed from DOM.
        // There is no need to process it. It will be processed when re-inserted.
        return;
      }

      var inlineFillerPosition = options.inlineFillerPosition;
      var actualDomChildren = this.domConverter.mapViewToDom(viewElement).childNodes;
      var expectedDomChildren = Array.from(this.domConverter.viewChildrenToDom(viewElement, domElement.ownerDocument, {
        bind: true,
        inlineFillerPosition: inlineFillerPosition
      })); // Inline filler element has to be created as it is present in the DOM, but not in the view. It is required
      // during diffing so text nodes could be compared correctly and also during rendering to maintain
      // proper order and indexes while updating the DOM.

      if (inlineFillerPosition && inlineFillerPosition.parent === viewElement) {
        addInlineFiller(domElement.ownerDocument, expectedDomChildren, inlineFillerPosition.offset);
      }

      var diff = this._diffNodeLists(actualDomChildren, expectedDomChildren);

      var i = 0;
      var nodesToUnbind = new Set(); // Handle deletions first.
      // This is to prevent a situation where an element that already exists in `actualDomChildren` is inserted at a different
      // index in `actualDomChildren`. Since `actualDomChildren` is a `NodeList`, this works like move, not like an insert,
      // and it disrupts the whole algorithm. See https://github.com/ckeditor/ckeditor5/issues/6367.
      //
      // It doesn't matter in what order we remove or add nodes, as long as we remove and add correct nodes at correct indexes.

      var _iterator9 = _createForOfIteratorHelper(diff),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var action = _step9.value;

          if (action === 'delete') {
            nodesToUnbind.add(actualDomChildren[i]);
            remove(actualDomChildren[i]);
          } else if (action === 'equal') {
            i++;
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      i = 0;

      var _iterator10 = _createForOfIteratorHelper(diff),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var _action = _step10.value;

          if (_action === 'insert') {
            insertAt(domElement, i, expectedDomChildren[i]);
            i++;
          } else if (_action === 'equal') {
            // Force updating text nodes inside elements which did not change and do not need to be re-rendered (#1125).
            // Do it here (not in the loop above) because only after insertions the `i` index is correct.
            this._markDescendantTextToSync(this.domConverter.domToView(expectedDomChildren[i]));

            i++;
          }
        } // Unbind removed nodes. When node does not have a parent it means that it was removed from DOM tree during
        // comparison with the expected DOM. We don't need to check child nodes, because if child node was reinserted,
        // it was moved to DOM tree out of the removed node.

      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }

      var _iterator11 = _createForOfIteratorHelper(nodesToUnbind),
          _step11;

      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var node = _step11.value;

          if (!node.parentNode) {
            this.domConverter.unbindDomElement(node);
          }
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
    }
    /**
     * Shorthand for diffing two arrays or node lists of DOM nodes.
     *
     * @private
     * @param {Array.<Node>|NodeList} actualDomChildren Actual DOM children
     * @param {Array.<Node>|NodeList} expectedDomChildren Expected DOM children.
     * @returns {Array.<String>} The list of actions based on the {@link module:utils/diff~diff} function.
     */

  }, {
    key: "_diffNodeLists",
    value: function _diffNodeLists(actualDomChildren, expectedDomChildren) {
      actualDomChildren = filterOutFakeSelectionContainer(actualDomChildren, this._fakeSelectionContainer);
      return diff(actualDomChildren, expectedDomChildren, sameNodes.bind(null, this.domConverter));
    }
    /**
     * Finds DOM nodes that were replaced with the similar nodes (same tag name) in the view. All nodes are compared
     * within one `insert`/`delete` action group, for example:
     *
     * 		Actual DOM:		<p><b>Foo</b>Bar<i>Baz</i><b>Bax</b></p>
     * 		Expected DOM:	<p>Bar<b>123</b><i>Baz</i><b>456</b></p>
     * 		Input actions:	[ insert, insert, delete, delete, equal, insert, delete ]
     * 		Output actions:	[ insert, replace, delete, equal, replace ]
     *
     * @private
     * @param {Array.<String>} actions Actions array which is a result of the {@link module:utils/diff~diff} function.
     * @param {Array.<Node>|NodeList} actualDom Actual DOM children
     * @param {Array.<Node>} expectedDom Expected DOM children.
     * @returns {Array.<String>} Actions array modified with the `replace` actions.
     */

  }, {
    key: "_findReplaceActions",
    value: function _findReplaceActions(actions, actualDom, expectedDom) {
      // If there is no both 'insert' and 'delete' actions, no need to check for replaced elements.
      if (actions.indexOf('insert') === -1 || actions.indexOf('delete') === -1) {
        return actions;
      }

      var newActions = [];
      var actualSlice = [];
      var expectedSlice = [];
      var counter = {
        equal: 0,
        insert: 0,
        delete: 0
      };

      var _iterator12 = _createForOfIteratorHelper(actions),
          _step12;

      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var action = _step12.value;

          if (action === 'insert') {
            expectedSlice.push(expectedDom[counter.equal + counter.insert]);
          } else if (action === 'delete') {
            actualSlice.push(actualDom[counter.equal + counter.delete]);
          } else {
            // equal
            newActions = newActions.concat(diff(actualSlice, expectedSlice, areSimilar).map(function (x) {
              return x === 'equal' ? 'replace' : x;
            }));
            newActions.push('equal'); // Reset stored elements on 'equal'.

            actualSlice = [];
            expectedSlice = [];
          }

          counter[action]++;
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }

      return newActions.concat(diff(actualSlice, expectedSlice, areSimilar).map(function (x) {
        return x === 'equal' ? 'replace' : x;
      }));
    }
    /**
     * Marks text nodes to be synchronized.
     *
     * If a text node is passed, it will be marked. If an element is passed, all descendant text nodes inside it will be marked.
     *
     * @private
     * @param {module:engine/view/node~Node} viewNode View node to sync.
     */

  }, {
    key: "_markDescendantTextToSync",
    value: function _markDescendantTextToSync(viewNode) {
      if (!viewNode) {
        return;
      }

      if (viewNode.is('$text')) {
        this.markedTexts.add(viewNode);
      } else if (viewNode.is('element')) {
        var _iterator13 = _createForOfIteratorHelper(viewNode.getChildren()),
            _step13;

        try {
          for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
            var child = _step13.value;

            this._markDescendantTextToSync(child);
          }
        } catch (err) {
          _iterator13.e(err);
        } finally {
          _iterator13.f();
        }
      }
    }
    /**
     * Checks if the selection needs to be updated and possibly updates it.
     *
     * @private
     */

  }, {
    key: "_updateSelection",
    value: function _updateSelection() {
      // If there is no selection - remove DOM and fake selections.
      if (this.selection.rangeCount === 0) {
        this._removeDomSelection();

        this._removeFakeSelection();

        return;
      }

      var domRoot = this.domConverter.mapViewToDom(this.selection.editableElement); // Do nothing if there is no focus, or there is no DOM element corresponding to selection's editable element.

      if (!this.isFocused || !domRoot) {
        return;
      } // Render selection.


      if (this.selection.isFake) {
        this._updateFakeSelection(domRoot);
      } else {
        this._removeFakeSelection();

        this._updateDomSelection(domRoot);
      }
    }
    /**
     * Updates the fake selection.
     *
     * @private
     * @param {HTMLElement} domRoot A valid DOM root where the fake selection container should be added.
     */

  }, {
    key: "_updateFakeSelection",
    value: function _updateFakeSelection(domRoot) {
      var domDocument = domRoot.ownerDocument;

      if (!this._fakeSelectionContainer) {
        this._fakeSelectionContainer = createFakeSelectionContainer(domDocument);
      }

      var container = this._fakeSelectionContainer; // Bind fake selection container with the current selection *position*.

      this.domConverter.bindFakeSelection(container, this.selection);

      if (!this._fakeSelectionNeedsUpdate(domRoot)) {
        return;
      }

      if (!container.parentElement || container.parentElement != domRoot) {
        domRoot.appendChild(container);
      }

      container.textContent = this.selection.fakeSelectionLabel || "\xA0";
      var domSelection = domDocument.getSelection();
      var domRange = domDocument.createRange();
      domSelection.removeAllRanges();
      domRange.selectNodeContents(container);
      domSelection.addRange(domRange);
    }
    /**
     * Updates the DOM selection.
     *
     * @private
     * @param {HTMLElement} domRoot A valid DOM root where the DOM selection should be rendered.
     */

  }, {
    key: "_updateDomSelection",
    value: function _updateDomSelection(domRoot) {
      var domSelection = domRoot.ownerDocument.defaultView.getSelection(); // Let's check whether DOM selection needs updating at all.

      if (!this._domSelectionNeedsUpdate(domSelection)) {
        return;
      } // Multi-range selection is not available in most browsers, and, at least in Chrome, trying to
      // set such selection, that is not continuous, throws an error. Because of that, we will just use anchor
      // and focus of view selection.
      // Since we are not supporting multi-range selection, we also do not need to check if proper editable is
      // selected. If there is any editable selected, it is okay (editable is taken from selection anchor).


      var anchor = this.domConverter.viewPositionToDom(this.selection.anchor);
      var focus = this.domConverter.viewPositionToDom(this.selection.focus);
      domSelection.collapse(anchor.parent, anchor.offset);
      domSelection.extend(focus.parent, focus.offset); // Firefox–specific hack (https://github.com/ckeditor/ckeditor5-engine/issues/1439).

      if (env.isGecko) {
        fixGeckoSelectionAfterBr(focus, domSelection);
      }
    }
    /**
     * Checks whether a given DOM selection needs to be updated.
     *
     * @private
     * @param {Selection} domSelection The DOM selection to check.
     * @returns {Boolean}
     */

  }, {
    key: "_domSelectionNeedsUpdate",
    value: function _domSelectionNeedsUpdate(domSelection) {
      if (!this.domConverter.isDomSelectionCorrect(domSelection)) {
        // Current DOM selection is in incorrect position. We need to update it.
        return true;
      }

      var oldViewSelection = domSelection && this.domConverter.domSelectionToView(domSelection);

      if (oldViewSelection && this.selection.isEqual(oldViewSelection)) {
        return false;
      } // If selection is not collapsed, it does not need to be updated if it is similar.


      if (!this.selection.isCollapsed && this.selection.isSimilar(oldViewSelection)) {
        // Selection did not changed and is correct, do not update.
        return false;
      } // Selections are not similar.


      return true;
    }
    /**
     * Checks whether the fake selection needs to be updated.
     *
     * @private
     * @param {HTMLElement} domRoot A valid DOM root where a new fake selection container should be added.
     * @returns {Boolean}
     */

  }, {
    key: "_fakeSelectionNeedsUpdate",
    value: function _fakeSelectionNeedsUpdate(domRoot) {
      var container = this._fakeSelectionContainer;
      var domSelection = domRoot.ownerDocument.getSelection(); // Fake selection needs to be updated if there's no fake selection container, or the container currently sits
      // in a different root.

      if (!container || container.parentElement !== domRoot) {
        return true;
      } // Make sure that the selection actually is within the fake selection.


      if (domSelection.anchorNode !== container && !container.contains(domSelection.anchorNode)) {
        return true;
      }

      return container.textContent !== this.selection.fakeSelectionLabel;
    }
    /**
     * Removes the DOM selection.
     *
     * @private
     */

  }, {
    key: "_removeDomSelection",
    value: function _removeDomSelection() {
      var _iterator14 = _createForOfIteratorHelper(this.domDocuments),
          _step14;

      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var doc = _step14.value;
          var domSelection = doc.getSelection();

          if (domSelection.rangeCount) {
            var activeDomElement = doc.activeElement;
            var viewElement = this.domConverter.mapDomToView(activeDomElement);

            if (activeDomElement && viewElement) {
              doc.getSelection().removeAllRanges();
            }
          }
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
    }
    /**
     * Removes the fake selection.
     *
     * @private
     */

  }, {
    key: "_removeFakeSelection",
    value: function _removeFakeSelection() {
      var container = this._fakeSelectionContainer;

      if (container) {
        container.remove();
      }
    }
    /**
     * Checks if focus needs to be updated and possibly updates it.
     *
     * @private
     */

  }, {
    key: "_updateFocus",
    value: function _updateFocus() {
      if (this.isFocused) {
        var editable = this.selection.editableElement;

        if (editable) {
          this.domConverter.focus(editable);
        }
      }
    }
  }]);

  return Renderer;
}();

export { Renderer as default };
mix(Renderer, ObservableMixin); // Checks if provided element is editable.
//
// @private
// @param {module:engine/view/element~Element} element
// @returns {Boolean}

function isEditable(element) {
  if (element.getAttribute('contenteditable') == 'false') {
    return false;
  }

  var parent = element.findAncestor(function (element) {
    return element.hasAttribute('contenteditable');
  });
  return !parent || parent.getAttribute('contenteditable') == 'true';
} // Adds inline filler at a given position.
//
// The position can be given as an array of DOM nodes and an offset in that array,
// or a DOM parent element and an offset in that element.
//
// @private
// @param {Document} domDocument
// @param {Element|Array.<Node>} domParentOrArray
// @param {Number} offset
// @returns {Text} The DOM text node that contains an inline filler.


function addInlineFiller(domDocument, domParentOrArray, offset) {
  var childNodes = domParentOrArray instanceof Array ? domParentOrArray : domParentOrArray.childNodes;
  var nodeAfterFiller = childNodes[offset];

  if (isText(nodeAfterFiller)) {
    nodeAfterFiller.data = INLINE_FILLER + nodeAfterFiller.data;
    return nodeAfterFiller;
  } else {
    var fillerNode = domDocument.createTextNode(INLINE_FILLER);

    if (Array.isArray(domParentOrArray)) {
      childNodes.splice(offset, 0, fillerNode);
    } else {
      insertAt(domParentOrArray, offset, fillerNode);
    }

    return fillerNode;
  }
} // Whether two DOM nodes should be considered as similar.
// Nodes are considered similar if they have the same tag name.
//
// @private
// @param {Node} node1
// @param {Node} node2
// @returns {Boolean}


function areSimilar(node1, node2) {
  return isNode(node1) && isNode(node2) && !isText(node1) && !isText(node2) && node1.nodeType !== Node.COMMENT_NODE && node2.nodeType !== Node.COMMENT_NODE && node1.tagName.toLowerCase() === node2.tagName.toLowerCase();
} // Whether two dom nodes should be considered as the same.
// Two nodes which are considered the same are:
//
//		* Text nodes with the same text.
//		* Element nodes represented by the same object.
//		* Two block filler elements.
//
// @private
// @param {String} blockFillerMode Block filler mode, see {@link module:engine/view/domconverter~DomConverter#blockFillerMode}.
// @param {Node} node1
// @param {Node} node2
// @returns {Boolean}


function sameNodes(domConverter, actualDomChild, expectedDomChild) {
  // Elements.
  if (actualDomChild === expectedDomChild) {
    return true;
  } // Texts.
  else if (isText(actualDomChild) && isText(expectedDomChild)) {
      return actualDomChild.data === expectedDomChild.data;
    } // Block fillers.
    else if (domConverter.isBlockFiller(actualDomChild) && domConverter.isBlockFiller(expectedDomChild)) {
        return true;
      } // Not matching types.


  return false;
} // The following is a Firefox–specific hack (https://github.com/ckeditor/ckeditor5-engine/issues/1439).
// When the native DOM selection is at the end of the block and preceded by <br /> e.g.
//
//		<p>foo<br/>[]</p>
//
// which happens a lot when using the soft line break, the browser fails to (visually) move the
// caret to the new line. A quick fix is as simple as force–refreshing the selection with the same range.


function fixGeckoSelectionAfterBr(focus, domSelection) {
  var parent = focus.parent; // This fix works only when the focus point is at the very end of an element.
  // There is no point in running it in cases unrelated to the browser bug.

  if (parent.nodeType != Node.ELEMENT_NODE || focus.offset != parent.childNodes.length - 1) {
    return;
  }

  var childAtOffset = parent.childNodes[focus.offset]; // To stay on the safe side, the fix being as specific as possible, it targets only the
  // selection which is at the very end of the element and preceded by <br />.

  if (childAtOffset && childAtOffset.tagName == 'BR') {
    domSelection.addRange(domSelection.getRangeAt(0));
  }
}

function filterOutFakeSelectionContainer(domChildList, fakeSelectionContainer) {
  var childList = Array.from(domChildList);

  if (childList.length == 0 || !fakeSelectionContainer) {
    return childList;
  }

  var last = childList[childList.length - 1];

  if (last == fakeSelectionContainer) {
    childList.pop();
  }

  return childList;
} // Creates a fake selection container for a given document.
//
// @private
// @param {Document} domDocument
// @returns {HTMLElement}


function createFakeSelectionContainer(domDocument) {
  var container = domDocument.createElement('div');
  container.className = 'ck-fake-selection-container';
  Object.assign(container.style, {
    position: 'fixed',
    top: 0,
    left: '-9999px',
    // See https://github.com/ckeditor/ckeditor5/issues/752.
    width: '42px'
  }); // Fill it with a text node so we can update it later.

  container.textContent = "\xA0";
  return container;
}